import React from 'react';
import TableYearsNavArrowsLeft from './TableYearsNavArrowsLeft';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

const RankYearsNavArrowsLeftContainer = () => {
  const { state: { columnState }, decreaseRankTablePosition } = useScorecardContext();
  const { rankTableIndex } = columnState;
  const isDisabled = rankTableIndex === 0;

  return (
    <TableYearsNavArrowsLeft
      isDisabled={ isDisabled }
      decreaseTablePosition={ decreaseRankTablePosition }
    />
  );
};

export default RankYearsNavArrowsLeftContainer;
